import React from "react";
import { Navigate } from "react-router-dom";

function LLMZone() {
  return <Navigate to="/llm/zones" />;
}
export default LLMZone;
